import React, { useState, useEffect } from "react";

import HRHero from "@/components/HRComponents/HRHero";
import HRProblemSolution from "@/components/HRComponents/HRProblemSolution";
import HRWhoIsThisFor from "@/components/HRComponents/HRWhoIsThisFor";
import HRCurriculum from "@/components/HRComponents/HRCurriculum";
import HRInstructor from "@/components/HRComponents/HRInstructor";
import FAQs from "../../components/MarketingFellowship/FAQs";
import CohortForm from "@/components/Forms/CohortForm";
import axios from "axios";
import { baseURL } from "@/utility/api";
import HRWhatYoullLearn from "@/components/HRComponents/HRWhatYoullLearn";
// import ConsultingHero from "../../components/MarketingFellowship/";
// import WhyFellowshipExists from "../components/WhyFellowshipExists";

// Main Page Component
const HRFellowshipPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [details, setDetails] = useState({});

  useEffect(() => {
    setIsVisible(true);
    async function fetchData() {
      const response = await axios.post(`${baseURL}/cohort/get-details`, {
        id: 106,
      });
      setDetails(response.data);
    }
    fetchData();
  }, []);
  // console.log("HR Fellowship Details:", details);
  return (
    <div className="min-h-screen bg-black text-white font-inter px-4 md:px-0">
      {/* Hero Section */}
      <HRHero CohortForm={CohortForm} details={details} />
      {/* About the Program Section */}
      <HRInstructor />
      <HRCurriculum />

      <HRProblemSolution />

      <HRWhatYoullLearn />
      <HRWhoIsThisFor />

      <FAQs />
    </div>
  );
};

export default HRFellowshipPage;
